import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useIdleTimeout } from '../hooks/useIdleTimeout';
import { getAuth0IdleTimeoutMs } from '../lib/auth0-env';

/**
 * Logs the user out after a period of client-side inactivity, aligned with Auth0 session policy.
 */
export function IdleSessionWatcher() {
  const { isAuthenticated } = useAuth0();
  const { logout } = useApp();
  const location = useLocation();

  const isPublicRoute = location.pathname.startsWith('/eoffer/');
  const enabled = isAuthenticated && !isPublicRoute;

  const handleIdle = useCallback(() => {
    logout();
  }, [logout]);

  useIdleTimeout(handleIdle, getAuth0IdleTimeoutMs(), enabled);

  return null;
}
